export default "__VITE_ASSET__hS$0f$xK__"